import { computed } from 'vue'
import { useTimeAgo } from '@vueuse/core'

export const timeAgo = (date) => {
    // Create a reactive Date object if 'date' is not already reactive
    const refTimeAgo = useTimeAgo(new Date(date), { max: Number.MAX_SAFE_INTEGER })

    return computed(() => refTimeAgo.value).value
}